import WellBeingPartnerSidebarInfo from './WellBeingPartnerSidebarInfo'

export default WellBeingPartnerSidebarInfo
